import { render, staticRenderFns } from "./cancelorderDia-shop.vue?vue&type=template&id=c2ab29b8&scoped=true"
import script from "./cancelorderDia-shop.vue?vue&type=script&lang=js"
export * from "./cancelorderDia-shop.vue?vue&type=script&lang=js"
import style0 from "./cancelorderDia-shop.vue?vue&type=style&index=0&id=c2ab29b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ab29b8",
  null
  
)

export default component.exports